import { render } from "./DefaultSlot.vue?vue&type=template&id=7ccbe5dd&scoped=true"
const script = {}

import "./DefaultSlot.vue?vue&type=style&index=0&id=7ccbe5dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ccbe5dd"]])

export default __exports__